import { Suspense } from 'react'
import { Header } from './Header'
import { Status } from './Status'
import { Conversation } from './Conversations'
import { KnowledgeBase } from './KnowledgeBase'
import { useTw } from '../../../../utils/Styles'
import { useProfile } from '../../../../utils/Profile'
import { KnowledgeBasePinned } from './KnowledgeBasePinned'
import { useWidgetOpen } from '../../../../utils'

export function Home() {
  const tw = useTw()
  const profile = useProfile()
  const { responsive, isMobile } = useWidgetOpen()

  return (
    <>
      <div
        style={{ background: profile?.background?.background ?? '#1E1E31' }}
        className={tw`inset-x-0 top-0 bg-fixed h-56 rounded-t-lg ${
          responsive && isMobile && 'rounded-none'
        }`}
      />
      <div className={tw`-mt-56 h-full overflow-y-auto`}>
        <Header />
        <Suspense fallback={<div />}>
          <div className={tw`-mt-20 pt-4 space-y-4 px-4 pb-4`}>
            <Conversation />
            {profile?.showKnowledgeBase ? (
              <>
                <KnowledgeBasePinned />
                <KnowledgeBase />
              </>
            ) : null}
            {profile?.showStatusPage ? <Status /> : null}
          </div>
        </Suspense>
      </div>
    </>
  )
}
